//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Result from './Result';
import ArchiveResult from './ArchiveResult';
import Pagination from './Pagination';

export default {
    name: "AppResults",
	components: {
        appResult: Result,
        appArchiveResult: ArchiveResult,
        appPagination: Pagination
	},
	computed: {
        ...mapGetters(['getResults', 'isArchive'])
    },
    methods: {
    }
};
